export default __webpack_public_path__ + "static/media/circle1.825df464.svg";